import type { ReactNode } from 'react';

import { Badge } from '@/components/ui/badge';
import { cn, getFileTypeColor } from '@/lib/utils';

// FAA/EASA/TCCA/CAD sub-types all collapse onto the single "AD" badge.
const AD_ALIASES = new Set([
    'faa ad',
    'easa ad',
    'tcca ad',
    'cad',
    'faa_ad',
    'easa_ad',
    'tcca_ad',
]);

/** Exported so a caller supplying its own `label` still collapses the AD sub-types. */
export function resolveDocTypeKey(type: string): string {
    const lower = type.toLowerCase();
    return AD_ALIASES.has(lower) ? 'ad' : lower;
}

export interface DocTypeBadgeProps {
    type: string;
    label?: ReactNode;
    className?: string;
    testId?: string;
}

export function DocTypeBadge({
    type,
    label,
    className,
    testId = 'DocTypeBadge',
}: DocTypeBadgeProps) {
    const key = resolveDocTypeKey(type);
    const displayLabel = label ?? key.toUpperCase();

    return (
        <Badge
            variant="outline"
            data-testid={testId}
            className={cn(
                'rounded-full font-medium shrink-0',
                getFileTypeColor(key),
                className,
            )}
        >
            {displayLabel}
        </Badge>
    );
}
